import { ASSET_SETTINGS, TRADING_SETTINGS } from "./assetSettingsMockData";

const delay = (ms = 80) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

/**
 * Trading settings API facade, mocked until the backend exposes the settings.
 */
export const assetSettingsService = {
  /**
   * @param {string} ticker asset ticker, e.g. "BTC"
   * @returns {Promise<{ maxProfit: number, riskSettings: object|null }>}
   *   riskSettings is null for an asset without market impact settings
   */
  getAssetSettings: async (ticker) => {
    await delay();

    const asset = ASSET_SETTINGS[String(ticker).toUpperCase()];

    return {
      maxProfit: asset?.maxProfit ?? TRADING_SETTINGS.maxProfit,
      riskSettings: asset?.riskSettings ?? null,
    };
  },
};
